module.exports = __webpack_public_path__ + "img/ITuranga64_ua.375629b8.webp";